// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.nav-toggle-button,
.expanded-nav-row,
.expanded-nav-sub-row,
.expanded-nav-sub-sub-row {
  background: none;
  border: 0;
  padding: 0;
  width: 100%;
  text-align: left;
}

.nav-row-button {
  appearance: none;
  -webkit-appearance: none;
  color: inherit;
  display: block;
  font: inherit;
  line-height: inherit;
}

.nav-list,
.nav-sub-list,
.nav-sub-sub-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-list,
.nav-sub-list,
.nav-sub-sub-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

/* Make buttons behave like your old clickable div rows */
.nav-toggle-button,
.collapsed-nav-row,
.collapsed-sub-nav-row {
  background: none;
  border: 0;
  padding: 0;
  width: 100%;
  text-align: left;
}

.collapsed-nav-container {
  border-radius: 10px;
  background-color: #676666;
  height: 65vh;
  margin-bottom: 32px;
  margin-right: 24px;
  max-width: 50px;
  padding: 8px;
}

.collapsed-nav-row {
  display: flex;
  justify-content: center;
  margin: 8px 0px;
  min-width: 30px;
}

.expanded-nav-container {
  border-radius: 10px;
  background-color: #676666;
  height: 65vh;
  margin-bottom: 32px;
  margin-right: 24px;
  min-width: 230px;
  padding: 8px;
}

.expanded-nav-arrow-row {
  display: flex;
  justify-content: flex-end;
}

.expanded-nav-row {
  margin: 8px 0px;
  padding: 0px 4px;
}

.expanded-nav-sub-row {
  cursor: pointer;
  margin: 4px 0px 8px 24px;
  font-size: 14px;
  padding: 0px 4px;
}

.expanded-nav-link {
  cursor: pointer;
  font-weight: 500;
  margin-left: 8px;
  text-decoration: none;
}

.arrow-icon {
  font-size: 24px;
  font-weight: 500;
}

.selected-row {
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 0px 4px;
}

.not-selected-row {
  color: white;
  padding: 0px 4px;
}

.child-selected {
  border-radius: 5px;
  border: 2px solid rgba(255, 255, 255, 0.8);
}

.white {
  color: white;
}

.dk-blue {
  color: #0A4064;
}

.expanded-nav-sub-sub-row {
  margin-left: 3rem;
  cursor: pointer;
  color: white;
  font-size: 0.9rem;
}

.collapsed-sub-nav-row {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  cursor: pointer;
  color: white;
}
.collapsed-sub-nav-row.selected-row {
  background-color: #cce0f4;
  color: #003366;
}

.small-icon {
  font-size: 0.85rem;
}

.tiny-icon {
  font-size: 0.5rem;
}

.historical-semester-note {
  background-color: #444343;
  border-radius: 5px;
  color: white;
  font-size: 12px;
  line-height: 1.3;
  margin-top: 16px;
  padding: 8px 10px;
  display: flex;
  align-items: flex-start;
  gap: 6px;
  max-width: 200px;
}
.historical-semester-note i {
  font-size: 14px;
  flex-shrink: 0;
  margin-top: 1px;
}
.historical-semester-note span {
  flex: 1;
}
.historical-semester-note.collapsed {
  justify-content: center;
  padding: 8px 4px;
}
.historical-semester-note.collapsed i {
  font-size: 16px;
  margin-top: 0;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/SidebarNav.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;;;;EAII,gBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;AAUJ;;AAPA;EACI,gBAAA;EACA,wBAAA;EACA,cAAA;EACA,cAAA;EACA,aAAA;EACA,oBAAA;AAUJ;;AAPA;;;EAGI,gBAAA;EACA,SAAA;EACA,UAAA;AAUJ;;AAPA;;;EAGI,gBAAA;EACA,SAAA;EACA,UAAA;AAUJ;;AAPA,yDAAA;AACA;;;EAGI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;AAUJ;;AAPA;EC/CI,mBDgDsB;EACtB,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AAUJ;;AAPA;EACI,aAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;AAUJ;;AANA;ECjEI,mBDkEsB;EACtB,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AASJ;;AANA;EACI,aAAA;EACA,yBAAA;AASJ;;AANA;EACI,eAAA;EACA,gBAAA;AASJ;;AANA;EACI,eAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;AASJ;;AANA;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AASJ;;AANA;EACI,eAAA;EACA,gBAAA;AASJ;;AALA;ECzGI,kBD0GsB;EACtB,0CAAA;EACA,gBAAA;AAQJ;;AALA;EACI,YAAA;EACA,gBAAA;AAQJ;;AALA;ECpHI,kBDqHsB;EACtB,0CAAA;AAQJ;;AALA;EACI,YAAA;AAQJ;;AALA;EACI,cDxHM;ACgIV;;AALA;EACI,iBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AAQJ;;AALA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AAQJ;AANI;EACI,yBAAA;EACA,cAAA;AAQR;;AAJA;EACI,kBAAA;AAOJ;;AAJA;EACI,iBAAA;AAOJ;;AAJA;EACI,yBDlIK;ECmIL,kBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;AAOJ;AANI;EACI,eAAA;EACA,cAAA;EACA,eAAA;AAQR;AALI;EACI,OAAA;AAOR;AAJI;EACI,uBAAA;EACA,gBAAA;AAMR;AAJQ;EACI,eAAA;EACA,aAAA;AAMZ","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.nav-toggle-button,\n.expanded-nav-row,\n.expanded-nav-sub-row,\n.expanded-nav-sub-sub-row {\n    background: none;\n    border: 0;\n    padding: 0;\n    width: 100%;\n    text-align: left;\n}\n\n.nav-row-button {\n    appearance: none;\n    -webkit-appearance: none;\n    color: inherit;\n    display: block;\n    font: inherit;\n    line-height: inherit;\n}\n\n.nav-list,\n.nav-sub-list,\n.nav-sub-sub-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.nav-list,\n.nav-sub-list,\n.nav-sub-sub-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n/* Make buttons behave like your old clickable div rows */\n.nav-toggle-button,\n.collapsed-nav-row,\n.collapsed-sub-nav-row {\n    background: none;\n    border: 0;\n    padding: 0;\n    width: 100%;\n    text-align: left;\n}\n\n.collapsed-nav-container {\n    @include borderRadius(10px);\n    background-color: #676666;\n    height: 65vh;\n    margin-bottom: 32px;\n    margin-right: 24px;\n    max-width: 50px;\n    padding: 8px;\n}\n\n.collapsed-nav-row {\n    display: flex;\n    justify-content: center;\n    margin: 8px 0px;\n    min-width: 30px;\n\n}\n\n.expanded-nav-container {\n    @include borderRadius(10px);\n    background-color: #676666;\n    height: 65vh;\n    margin-bottom: 32px;\n    margin-right: 24px;\n    min-width: 230px;\n    padding: 8px;\n}\n\n.expanded-nav-arrow-row {\n    display: flex;\n    justify-content: flex-end;\n}\n\n.expanded-nav-row {\n    margin: 8px 0px;\n    padding: 0px 4px;\n}\n\n.expanded-nav-sub-row {\n    cursor: pointer;\n    margin: 4px 0px 8px 24px;\n    font-size: 14px;\n    padding: 0px 4px;\n}\n\n.expanded-nav-link {\n    cursor: pointer;\n    font-weight: 500;\n    margin-left: 8px;\n    text-decoration: none;\n}\n\n.arrow-icon {\n    font-size: 24px;\n    font-weight: 500;\n}\n\n\n.selected-row {\n    @include borderRadius(5px);\n    background-color: rgba(255, 255, 255, .8);\n    padding: 0px 4px;\n}\n\n.not-selected-row {\n    color: white;\n    padding: 0px 4px;\n}\n\n.child-selected {\n    @include borderRadius(5px);\n    border: 2px solid rgba(255, 255, 255, .8);\n}\n\n.white {\n    color: white;\n}\n\n.dk-blue {\n    color: $dk-blue;\n}\n\n.expanded-nav-sub-sub-row {\n    margin-left: 3rem;\n    cursor: pointer;\n    color: white;\n    font-size: 0.9rem;\n}\n\n.collapsed-sub-nav-row {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 6px;\n    cursor: pointer;\n    color: white;\n\n    &.selected-row {\n        background-color: #cce0f4;\n        color: #003366;\n    }\n}\n\n.small-icon {\n    font-size: 0.85rem;\n}\n\n.tiny-icon {\n    font-size: 0.5rem;\n}\n\n.historical-semester-note {\n    background-color: $grey4a;\n    border-radius: 5px;\n    color: white;\n    font-size: 12px;\n    line-height: 1.3;\n    margin-top: 16px;\n    padding: 8px 10px;\n    display: flex;\n    align-items: flex-start;\n    gap: 6px;\n    max-width: 200px;\n    i {\n        font-size: 14px;\n        flex-shrink: 0;\n        margin-top: 1px;\n    }\n\n    span {\n        flex: 1;\n    }\n\n    &.collapsed {\n        justify-content: center;\n        padding: 8px 4px;\n\n        i {\n            font-size: 16px;\n            margin-top: 0;\n        }\n    }\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
